import { useState, useEffect, useCallback } from 'react';

import { SplashScreen } from 'src/components/loading-screen';
import { useRouter } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';

import { useAuthStore } from '../store/auth.store';

type Props = {
  children: React.ReactNode;
};

export default function AuthGuard({ children }: Props) {
  const router = useRouter();
  const { isAuthenticated, isLoading } = useAuthStore();
  const [checked, setChecked] = useState(false);

  const check = useCallback(() => {
    if (!isAuthenticated) {
      const searchParams = new URLSearchParams({
        returnTo: window.location.pathname,
      }).toString();

      const href = `${paths.auth.login}?${searchParams}`;
      router.replace(href);
    } else {
      setChecked(true);
    }
  }, [isAuthenticated, router]);

  useEffect(() => {
    check();
  }, [check]);

  if (isLoading) {
    return <SplashScreen />;
  }

  if (!checked) {
    return null;
  }

  return <>{children}</>;
}
